import React,{useState,useEffect} from 'react'
import './TopRec.css';
import axios from 'axios';
import { LoadingOutlined } from '@ant-design/icons';

function TopRec() {
  const [companyList,setCompanyList] = useState([])
  const [loading, setLoading] = useState(true);

  useEffect(() => {       
      let source = axios.CancelToken.source();

      async function fetchData() {
          try {
              const res = await axios.get("https://api.360ep.cn/api/company?type=sep", {
                  cancelToken: source.token
              });

              let companies = [];
              res.data.data.forEach(item => {                
                  companies.push({
                      name: item.Company,
                      url:  item.LinkUrl,
                      img:  item.Thumb,
                      alt:  item.Brand,
                      main: item.Business,
                      type: '公司',
                      region: item.Areaname,
                  });
                  
              });

              setCompanyList(companies);    
              setLoading(false);         
          } catch (error) {
              if (axios.isCancel(error)) {
                  console.log("Request canceled", error.message);
              } else {
                  console.log("Error", error.message);
              }
          }
      }

      fetchData();

      return () => {
          source.cancel("Request canceled by user");
      };
  }, []);

  if (loading) {
    return <div><LoadingOutlined /></div>;
  }

  return (
    <div className="zuijia-top">
      <div className="left zuijia-right">
        <ul className="company-list">
          {companyList.map((company, index) => (
            <li className="company-item" key={index}>
              <div className="cmp-img">
                <a href={company.url} target="_blank" rel="noopener noreferrer">
                  <img
                    src={company.img}
                    alt={company.alt}
                    style={{ width: '100%',height:'100%' }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/skin/360ep//image/no_img7.png';
                    }}
                  />
                </a>
              </div>
              <div className="cmp-name">
                <a href={company.url} target="" rel="noopener noreferrer">
                <span className="orange">{company.name}</span>
                </a>
              </div>
              <p className="cmp-zy">
                <span className="orange">主营：</span>
                {company.main}
              </p>
              <div className="lianxi-cmp left-align">
                <div>
                <span className="orange">{company.type}</span>
                &nbsp;&nbsp;|&nbsp;&nbsp;<span>{company.region}</span>
                </div>
                <a
                  href={company.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="right"
                >
                  联系我
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default TopRec;
